(function () {
  var loading = {}
  var productScriptNames = ['productCore', 'productVariants', 'productBundleCore', 'productBundleList', 'productBundles', 'productGallery', 'productContent']

  function loadScript(name) {
    if (!name) return Promise.resolve()
    if (loading[name]) return loading[name]
    if (document.querySelector('[data-dpp-theme-script="' + name + '"]')) return Promise.resolve()

    var assetMap = window.DPPThemeAssets || {}
    var src = assetMap[name]
    if (!src) return Promise.resolve()

    loading[name] = new Promise(function (resolve, reject) {
      var script = document.createElement('script')
      script.src = src
      script.defer = true
      script.setAttribute('data-dpp-theme-script', name)
      script.onload = function () { resolve() }
      script.onerror = function () { reject(new Error('load_failed:' + name)) }
      document.head.appendChild(script)
    })

    return loading[name]
  }

  productScriptNames.reduce(function (chain, name) {
    return chain.then(function () { return loadScript(name) })
  }, Promise.resolve()).catch(function () {})
})()
